
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

window.initGlobalSwiper = function() {
  // .swiper (旧: .swiper-container)
  new Swiper('.swiper', {
	slidesPerView: 2.5,
	freeMode: {
	  enabled: true,
	  momentumBounce: true,
	},
	breakpoints: {
	  767: {
		slidesPerView: 4,
		navigation: {
		  nextEl: ".next-arrow",
		  prevEl: ".prev-arrow",
		},
	  },
	}
  });

  // .talent-relation-swiper
  new Swiper('.talent-relation-swiper', {
	slidesPerView: 2.5,
	freeMode: {
	  enabled: true,
	  momentumBounce: true,
	},
	slidesOffsetBefore: 0,
	breakpoints: {
	  767: {
		slidesPerView: 3,
		navigation: {
		  nextEl: ".next-arrow",
		  prevEl: ".prev-arrow",
		},
	  },
	},
  });

  // .relation-item-swiper
  new Swiper('.relation-item-swiper', {
	slidesPerView: 2.5,
	freeMode: {
	  enabled: true,
	  momentumBounce: true,
	},
	slidesOffsetBefore: 0,
	breakpoints: {
	  767: {
		slidesPerView: 4,
		navigation: {
		  nextEl: ".next-arrow",
		  prevEl: ".prev-arrow",
		},
	  },
	}
  });

  // .relation-column-swiper
  new Swiper('.relation-column-swiper', {
	freeMode: {
	  enabled: true,
	  momentumBounce: true,
	},
	slidesOffsetBefore: 0,
	breakpoints: {
	  767: {
		slidesPerView: 3,
		navigation: {
		  nextEl: ".next-arrow",
		  prevEl: ".prev-arrow",
		},
	  },
	}
  });

  // .relation-plus-swiper
  new Swiper('.relation-plus-swiper', {
	slidesPerView: 2.5,
	freeMode: {
	  enabled: true,
	  momentumBounce: true,
	},
	slidesOffsetBefore: 0,
	breakpoints: {
	  767: {
		slidesPerView: 4,
		navigation: {
		  nextEl: ".next-arrow",
		  prevEl: ".prev-arrow",
		},
	  },
	},
	on: {
	  init: function () {
		var slideCount = this.slides.length;
		if (slideCount <= 3) {
		  this.params.slidesPerView = 'auto';
		  this.allowTouchMove = false;
		  this.update();
		}
	  },
	},
  });

  // .relation-news-swiper
  new Swiper('.relation-news-swiper', {
	freeMode: {
	  enabled: true,
	  momentumBounce: true,
	},
	slidesOffsetBefore: 0,
	slidesPerView: 3,
	navigation: {
	  nextEl: ".next-arrow-news",
	  prevEl: ".prev-arrow-news",
	},
  });
};